import { createSlice } from "@reduxjs/toolkit";
import Socket from "Socket/socket.js";
import { closeSocket } from "./socketDuck";

const addTimeStamp = (data) => {
  const date = new Date();
  // dd.mm hh:mm
  const timeStamp = `${date.getDate()}.${date.getMonth() + 1} ${("0" + date.getHours()).slice(-2)}:${("0" + date.getMinutes()).slice(-2)}`;
  return { ...data, timeStamp };
};

export const systemDefaultState = {
  config: undefined,
  isNetworkConnected: false,
  toastAlerts: [],
  latestAlert: null,
};

const systemSlice = createSlice({
  name: "system",
  initialState: systemDefaultState,
  reducers: {
    setNetworkConnection(state, action) {
      state.isNetworkConnected = action.payload.isNetworkConnected;
    },
    getConfig(state, action) {
      const { data } = action.payload;
      state.config = data;
      Socket.connect(data);
    },
    fetchEventUpdateSocket(state, action) {
      const { data } = action.payload;

      // Only handle toast if it has a reason (meaning there is a message to display)
      if (data.Reason) {
        const toastArray = state.toastAlerts;
        const dataWithAddedTimeStamp = addTimeStamp(data);
        console.log("dataWithAddedTimeStamp", dataWithAddedTimeStamp);
        state.latestAlert = dataWithAddedTimeStamp;
        toastArray.push(dataWithAddedTimeStamp);
        // toastArray max length is 25, drop the oldest toast if it exceeds 25
        if (toastArray.length > 25) {
          toastArray.shift();
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(closeSocket, (state, action) => {
      Socket.disconnect(state.config);
    });
  },
});

export const { setNetworkConnection, getConfig, fetchEventUpdateSocket } =
  systemSlice.actions;

export default systemSlice.reducer;
